import { Widget } from '@asset-metrix/portal-ui';

import { useContentEditActions } from './useContentEditActions';

import styles from './pageEditDummyWidget.module.scss';

export type PageEditDummyWidgetProps = {
  pageId: string;
  widgetId: string;
  title: string;
};

/** Empty widget shell for Add Component draft widgets — no live data fetches. */
export function PageEditDummyWidget({
  pageId,
  widgetId,
  title,
}: PageEditDummyWidgetProps) {
  const actions = useContentEditActions(pageId, widgetId, []);

  return (
    <Widget
      title={title}
      actions={actions}
      dataTestId="page-edit-dummy-widget"
      classNames={{ root: styles.root }}
    >
      <div className={styles.body} />
    </Widget>
  );
}
